import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const DataIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12 2C6.55868 2 2.13242 2.75799 2.00292 3.70159H2V8.04065H2.00292C2.00098 8.05479 2 8.06897 2 8.08319C2 9.04645 6.47715 9.82733 12 9.82733C17.5228 9.82733 22 9.04645 22 8.08319C22 8.06897 21.999 8.05479 21.9971 8.04065H22V3.70159H21.9971C21.8676 2.75799 17.4413 2 12 2Z'
        fill={color}
      />
      <path
        d='M2.02904 9.65087C3.41867 10.4455 7.35773 11.0184 12 11.0184C16.6423 11.0184 20.5813 10.4455 21.971 9.65087C21.9841 9.68112 21.9929 9.71158 21.9971 9.74224H22V14.0813H21.9971C21.999 14.0954 22 14.1096 22 14.1238C22 15.0871 17.5228 15.868 12 15.868C6.47715 15.868 2 15.0871 2 14.1238C2 14.1096 2.00098 14.0954 2.00292 14.0813H2V9.74224H2.00292C2.00712 9.71158 2.01587 9.68112 2.02904 9.65087Z'
        fill={color}
      />
      <path
        d='M12 17.1505C7.35773 17.1505 3.41867 16.5775 2.02904 15.7829C2.01587 15.8131 2.00712 15.8436 2.00292 15.8743H2V20.2133H2.00292C2.00098 20.2275 2 20.2416 2 20.2559C2 21.2191 6.47715 22 12 22C17.5228 22 22 21.2191 22 20.2559C22 20.2416 21.999 20.2275 21.9971 20.2133H22V15.8743H21.9971C21.9929 15.8436 21.9841 15.8131 21.971 15.7829C20.5813 16.5775 16.6423 17.1505 12 17.1505Z'
        fill={color}
      />
    </svg>
  )
})

DataIcon.displayName = 'DataIcon'
